import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { featureFlags } from '../FeatureFlagsContextProvider/FeatureFlagsContextProvider'
import { GoogleIcon } from '../../assets/google_logo'
interface Props {
  onGoogleSignIn: () => Promise<void>
  loading: boolean
}

export const LoginForm = ({ onGoogleSignIn, loading }: Props) => {
  const navigate = useNavigate()
  const { isCompanyCreationEnabled } = useContext(featureFlags)
  const [isRedirecting, setIsRedirecting] = useState(false)

  const handleGoogleClick = async () => {
    setIsRedirecting(true)
    try {
      await onGoogleSignIn()
    } catch {
      setIsRedirecting(false)
    }
  }

  const isBusy = loading || isRedirecting

  return (
    <div className="login-card">
      <div className="login-card__content">
        <h1 className="login-card__title">Welcome to Matrix Managed!</h1>

        <p className="login-card__description">
          Access to this application is restricted to users with an{' '}
          <span className="login-card__email">@acklenavenue.com</span> email
          address.
        </p>

        <button
          type="button"
          className="login-card__google-btn"
          disabled={isBusy}
          aria-label="google-login-button"
          onClick={handleGoogleClick}
        >
          <GoogleIcon />
          {isBusy ? 'Redirecting to Google...' : 'Continue with Google'}
        </button>

        <p className="login-card__terms">
          By signing in, you agree to Acklen Avenue&apos;s terms of service.
        </p>

        {isCompanyCreationEnabled && (
          <button
            type="button"
            className="login-card__register-link"
            onClick={() => navigate('/register-company')}
          >
            Register New Company
          </button>
        )}
      </div>
    </div>
  )
}
